import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import Logo from "../assets/images/logo.png";
import { CiFacebook } from "react-icons/ci";
import { CiInstagram } from "react-icons/ci";
import { CiTwitter } from "react-icons/ci";
import { SlLocationPin } from "react-icons/sl";
import { IoCallOutline } from "react-icons/io5";
import { IoMailOpenOutline } from "react-icons/io5";
import { FaWhatsapp } from "react-icons/fa";
const Footer = () => {
  return (
    <footer>
      <div className="main-footer">
        <Container>
          <Row>
            <Col lg={4} md={6} sm={6} className="order-lg-1 order-1">
              <div className="footer-content">
                <img src={Logo} alt="footer-logo" loading="lazy" />
                <p>
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed
                  do eiusmod tempor incididunt ut labore et dolore magna aliqua.
                </p>
                <ul>
                  <li>
                    <a href="#" target="_blank" rel="noopener noreferrer">
                      <CiFacebook />
                    </a>
                  </li>
                  <li>
                    <a href="#" target="_blank" rel="noopener noreferrer">
                      <CiTwitter />
                    </a>
                  </li>
                  <li>
                    <a href="#" target="_blank" rel="noopener noreferrer">
                      <CiInstagram />
                    </a>
                  </li>
                  <li>
                    <a href="https://wa.me/+971503580352" target="_blank" rel="noopener noreferrer">
                      <FaWhatsapp />
                    </a>
                  </li>
                </ul>
              </div>
            </Col>
            <Col lg={4} md={12} className="order-lg-2 order-3" >
              <div className="footer-map">
                <iframe
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3628.848299190457!2d55.64763370000001!3d25.358718699999997!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3ef5f3a997c2dbe3%3A0xbdbae623ba809f68!2sCARAP%20ROYAL%20GLOBAL%20TRADING%20CO%20L.L.C!5e1!3m2!1sen!2sin!4v1761912054286!5m2!1sen!2sin"
                  width="100%"
                  height="100%"
                  allowfullscreen=""
                  loading="lazy"
                  referrerpolicy="no-referrer-when-downgrade"
                ></iframe>
              </div>
            </Col>
            <Col lg={4} md={6} sm={6} className="order-lg-3 order-2">
              <div className="footer-contact">
                <h3>Support</h3>
                <ul>
                    <li>
                        <a href="https://maps.app.goo.gl/QHws3sc3UYzvFPH4A" target="_blank" rel="noopener noreferrer" >
                            <SlLocationPin />
                            <span>4-5 AL kebbesi, Deire, <br /> Dubai United Arab Emirates</span>
                        </a>
                    </li>
                    
                    <li>
                        <a href="tel:+971503580352" >
                            <IoCallOutline />
                            <span>+971503580352</span>
                        </a>
                    </li>
                    <li>
                        <a href="mailto:carapglobal@gmail.com" >
                            <IoMailOpenOutline />
                            <span>carapglobal@gmail.com</span>
                        </a>
                    </li>
                </ul>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
      <div className="footer-bottom">
        <Container>
          <div className="copyright-text">
            <p>
              © 2025, All rights reserved by <span>Carap</span>
            </p>
          </div>
        </Container>
      </div>
    </footer>
  );
};

export default Footer;
